/**
 * ProductType Endpoints
 */

export const apiPostProductType = async (
  productType: ProductTypeCreateUpdate,
): Promise<AxiosResponse<ProductType>> => {
  return await userManagementAxiosInstance.post('product_types', productType);
};

export const apiGetProductTypes = async (
  limit: number = defaultLimit,
  offset: number = defaultOffset,
  search: string = '',
): Promise<AxiosResponse<PaginatedProductType>> => {
  return await userManagementAxiosInstance.get(
    `product_types?limit=${limit}&offset=${offset}&name=${search}`,
  );
};

export const apiGetProductType = async (
  id: string | number,
): Promise<AxiosResponse<ProductType>> => {
  return await userManagementAxiosInstance.get(`product_types/${id}`);
};

export const apiPutProductType = async (
  productType: ProductTypeCreateUpdate,
): Promise<AxiosResponse<ProductType>> => {
  return await userManagementAxiosInstance.put(`product_types/${productType.id}`, productType);
};

export const apiDeleteProductType = async (
  id: string | number,
): Promise<AxiosResponse<ProductType>> => {
  return await userManagementAxiosInstance.delete(`product_types/${id}`);
};
